import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CameraPost } from '@classes/camera/camera';
import { CamerasService } from '@services/cameras/cameras.service';

@Component({
  selector: 'app-smartparking-cameras-add',
  templateUrl: './smartparking-cameras-add.component.html',
  styleUrls: ['./smartparking-cameras-add.component.scss']
})
export class SmartparkingCamerasAddComponent implements OnInit {
  addCameraForm: UntypedFormGroup;
  inactive = true;
  ArrayValueInput: string[] = [];
  confirmAdd = false;


  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    private cameraService: CamerasService,
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {

    if (this.addCameraForm.invalid) {
      this.inactive = true;
      return;
    }

    const camera: CameraPost = {
      name: this.addCameraForm.get('name').value,
      ip: this.addCameraForm.get('ip').value,
      port: this.addCameraForm.get('port').value
    };

    this.cameraService.addCamera(camera).subscribe(() => {
      this.confirmAdd = true;
      setTimeout(() => {

        this.dialog.closeAll();
      }, 3000);
    });

  }

  isInactive(): void {
    let inputValue = true;
    const inputs = document.querySelectorAll('input');
    const regex = /^-?(0|[1-9]\d*)?$/;

    inputs.forEach(input => {
      !input.value ? inputValue = false :
        input.id !== 'port' ?
          inputValue = true :
          this.addCameraForm.invalid ? inputValue = false : inputValue = true;
    });

    inputValue ? this.inactive = false : this.inactive = true;
  }

  private initForm(): void {
    this.addCameraForm = this.formBuilder.group({
      name: ['', Validators.required],
      ip: ['', Validators.required],
      port: ['', [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]]
    });
  }

}
